import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadCMBSSecurityTypesService from "services/cmbs/loadCMBSSecurityTypesService";

function SelectOfferingType({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  readOnly
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadCMBSSecurityTypesService}
      onSelect={onSelect}
      textPath="sec_description"
      labelPath="sec_code"
      idPath="sec_code"
      disabled={disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
    />
  );
}

SelectOfferingType.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string
};

SelectOfferingType.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search..."
};

export default SelectOfferingType;
